import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IAuthMedia } from '../../models/auth-media.interface';

@Component({
  selector: 'epc-auth-backdrop',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './backdrop.component.html',
  styleUrls: ['./backdrop.component.scss'],
  standalone: false,
})
export class AuthBackdropComponent {
  @Input({ required: true })
  public media: IAuthMedia | null = null;
}
